@if(!inject.showChart){
  <div #kpiContainer class="absolute inset-0 flex justify-center items-center overflow-hidden">
    <ng-container *ngTemplateOutlet="kpiValueContainer;"></ng-container>
  </div>
}

@if(inject.showChart){
  <div class="absolute inset-0 overflow-hidden">
    <div #kpiContainer class="absolute top-0 left-0 w-full z-10 flex justify-center items-center" style="height: 30%;">
      <ng-container *ngTemplateOutlet="kpiValueContainer;"></ng-container>
    </div>
    <div class="absolute bottom-0 left-0 w-full overflow-hidden" style="height: 70%;">
      <eda-chart #EdaChart [inject]="inject.edaChart" class="h-full w-full"></eda-chart>
    </div>
  </div>
}

<ng-template #kpiValueContainer>
    <div #sufixContainer class="pointer" title="Añadir unidades"
         style="max-width: 100%; overflow: hidden;">
        <span [ngStyle]="getStyle()" (click)="setSufix()"
              style="display: block; text-align: center; overflow-wrap: break-word; word-break: break-word;">
            <img *ngIf="inject.prefixImage" [src]="inject.prefixImage" alt=""
                 style="height: 1em; width: auto; vertical-align: middle; object-fit: contain; display: inline;" />
            {{inject.value | number:'1.0-10':'es' }} {{inject.sufix}}
        </span>

        @if(!!sufixClick){
          <div class="ui-inputgroup w-100" style="margin-top: 0.25em;">
            <input type="text" pInputText [(ngModel)]="inject.sufix" (focusout)="setSufix()"
              (keydown.enter)="setSufix()" name="unidades" autofocusOnShow
              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#00BFB3] focus:border-[#00BFB3] text-sm"/>
          </div>
        }
    </div>
</ng-template>
